import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import { toursFieldsMap } from './fields';
import { IDataContainerService } from 'app/interfaces/data-container.interface';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

toursFieldsMap.forEach(function(value, key, map): void{
	value = Object.assign({}, value);
	fieldsMap.set(key, value);
});

fieldsMap.set('enable_push_availability', {
	key: 'enable_push_availability',
	name: 'Enable Push Availability',
	inputType: InputTypes.SELECT,
	valueType: ValueTypes.BOOLEAN,
	formValidators: [ Validators.required ],
	options: [
		{
			label: 'Disabilitato',
			value: false
		},
		{
			label: 'Abilitato',
			value: true
		}
	]
});

fieldsMap.set('parameters.endpoint', {
	key: 'parameters.endpoint',
	name: 'Endpoint',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('parameters.marketplace_id', {
	key: 'parameters.marketplace_id',
	name: 'Marketplace ID',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('parameters.private_key', {
	key: 'parameters.private_key',
	name: 'Private Key',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('parameters.channel', {
	key: 'parameters.channel',
	name: 'Canale',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('parameters.marketplace_private_key', {
	key: 'parameters.marketplace_private_key',
	name: 'Marketplace Private Key',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('parameters.marketplace_account_id', {
	key: 'parameters.marketplace_account_id',
	name: 'Marketplace Account ID',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING
});

fieldsMap.set('scenario', {
	key: 'scenario',
	name: '',
	inputType: InputTypes.HIDDEN,
	valueType: ValueTypes.STRING,
	fieldView: FieldViews.HIDDEN,
	formValidators: [ Validators.required ],
	defaultValue(dataContainerService: IDataContainerService) {
		return 'touroperators.tour-cms';
	}
});

export {fieldsMap as tourCmsFieldsMap};
